import React from 'react';
import styled from 'styled-components';
import profileImage from '../assets/profile.jpg';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: #dfe6e9;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #b2bec3;
  max-width: 600px;
  margin: 0 auto;
`;

const Content = styled.div`
  background: #2d3436;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #3d4346;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #74b9ff;
  margin-bottom: 1rem;
  font-size: 1.5rem;
`;

const Paragraph = styled.p`
  color: #b2bec3;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  color: #b2bec3;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  border: 3px solid #74b9ff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const AboutPage: React.FC = () => {
  return (
    <Container>
      <Header>
        <ProfileImage src={profileImage} alt="Armen's Profile" />
        <PageTitle>About Me</PageTitle>
        <Subtitle>Game Developer, Programmer, and Open Source Enthusiast</Subtitle>
      </Header>
      <Content>
        <Section>
          <SectionTitle>Who Am I?</SectionTitle>
          <Paragraph>
            I'm a passionate game developer and programmer with a strong focus on creating engaging experiences
            using the Godot game engine. My journey in game development has led me to create various games,
            from tactical RPGs to puzzle games, each with its own unique mechanics and challenges.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>My Games</SectionTitle>
          <Paragraph>
            I've developed several games that showcase my skills and creativity:
          </Paragraph>
          <List>
            <ListItem>BookSmart Quartets - A strategic card game about collecting matching books</ListItem>
            <ListItem>Berated - A unique game with its own distinct mechanics</ListItem>
            <ListItem>Surge! - An engaging game experience</ListItem>
            <ListItem>Titan Tactics - A tactical game with strategic depth</ListItem>
            <ListItem>Do It Later - A game about time management</ListItem>
            <ListItem>Pocket Tactics - A portable tactical experience</ListItem>
            <ListItem>Tiny Tactics - A strategy turn-based combat game in 64 pixels</ListItem>
            <ListItem>Bathroom Escape - A puzzle game created for Taku's Mini Jam</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Development Approach</SectionTitle>
          <Paragraph>
            I believe in creating games that are not only fun to play but also technically sound.
            My development process focuses on:
          </Paragraph>
          <List>
            <ListItem>Clean, maintainable code</ListItem>
            <ListItem>Efficient game mechanics</ListItem>
            <ListItem>User-friendly interfaces</ListItem>
            <ListItem>Cross-platform compatibility</ListItem>
            <ListItem>Open source development practices</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Community Involvement</SectionTitle>
          <Paragraph>
            I'm an active member of the game development community, participating in:
          </Paragraph>
          <List>
            <ListItem>Game jams and development challenges</ListItem>
            <ListItem>Open source contributions</ListItem>
            <ListItem>Knowledge sharing through social media</ListItem>
            <ListItem>Community discussions on Matrix</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Connect With Me</SectionTitle>
          <Paragraph>
            I'm always interested in connecting with fellow developers and gamers. You can find me on:
          </Paragraph>
          <List>
            <ListItem>Mastodon (@armen@gamedev.place) - For game development updates and discussions</ListItem>
            <ListItem>Pixelfed (@armen@pixelfed.ca) - For visual content and development screenshots</ListItem>
            <ListItem>Matrix Chat - For real-time discussions about game development</ListItem>
          </List>
        </Section>
      </Content>
    </Container>
  );
};

export default AboutPage; 